import { render, staticRenderFns } from "./GoIncident.vue?vue&type=template&id=71801253"
import script from "./GoIncident.vue?vue&type=script&lang=js"
export * from "./GoIncident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports